import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Button, Form, Alert, Spinner, Row, Col } from 'react-bootstrap';
import { assessmentStore } from '../stores/AssessmentStore';
const AssessmentDialog = observer(({ parentId }) => {
    const [formData, setFormData] = useState({
        name: '',
        parentId: parentId || null
    });
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (assessmentStore.isEditing && assessmentStore.selectedAssessment) {
            setFormData({
                name: assessmentStore.selectedAssessment.name,
                parentId: assessmentStore.selectedAssessment.parentId
            });
        }
        else {
            setFormData({
                name: '',
                parentId: parentId || null
            });
        }
        setErrors({});
    }, [assessmentStore.isDialogOpen, assessmentStore.isEditing, assessmentStore.selectedAssessment, parentId]);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value === '' ? null : value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };
    const validateForm = () => {
        const newErrors = {};
        if (!formData.name.trim()) {
            newErrors.name = 'Assessment name is required';
        }
        else if (formData.name.trim().length < 2) {
            newErrors.name = 'Assessment name must be at least 2 characters long';
        }
        else if (formData.name.trim().length > 100) {
            newErrors.name = 'Assessment name cannot exceed 100 characters';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        try {
            const assessmentData = {
                name: formData.name.trim(),
                parentId: formData.parentId || null
            };
            if (assessmentStore.isEditing && assessmentStore.selectedAssessment) {
                await assessmentStore.updateAssessment(assessmentStore.selectedAssessment.id, assessmentData);
            }
            else {
                await assessmentStore.createAssessment(assessmentData);
            }
            assessmentStore.closeDialog();
        }
        catch (error) {
            // Error is handled by the store
        }
    };
    const handleClose = () => {
        assessmentStore.closeDialog();
    };
    const isCreatingCriteria = parentId !== undefined && parentId !== null;
    const isEditingArea = assessmentStore.isEditing && assessmentStore.selectedAssessment?.parentId === null;
    const isEditingCriteria = assessmentStore.isEditing && assessmentStore.selectedAssessment?.parentId !== null;
    return (_jsxs(Modal, { show: assessmentStore.isDialogOpen, onHide: handleClose, size: "lg", children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: assessmentStore.isEditing
                        ? (isEditingArea ? 'Edit Assessment Area' : 'Edit Assessment Criteria')
                        : (isCreatingCriteria ? 'Add New Assessment Criteria' : 'Add New Assessment Area') }) }), _jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs(Modal.Body, { children: [assessmentStore.hasError && (_jsx(Alert, { variant: "danger", className: "mb-3", children: assessmentStore.error })), _jsx(Row, { children: _jsx(Col, { md: 12, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsxs(Form.Label, { children: [isCreatingCriteria || isEditingCriteria ? 'Criteria Name' : 'Area Name', " *"] }), _jsx(Form.Control, { type: "text", name: "name", value: formData.name, onChange: handleInputChange, isInvalid: !!errors.name, placeholder: isCreatingCriteria || isEditingCriteria ? "e.g., Defense, Pull shots" : "e.g., Batting, Bowling", disabled: assessmentStore.isLoading }), _jsx(Form.Control.Feedback, { type: "invalid", children: errors.name })] }) }) }), !isCreatingCriteria && !isEditingCriteria && (_jsx(Row, { children: _jsx(Col, { md: 12, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Parent Assessment Area (Optional)" }), _jsx(Form.Text, { className: "text-muted d-block mb-2", children: "Leave empty to create an assessment area. Select an area to create criteria under it." }), _jsxs(Form.Select, { name: "parentId", value: formData.parentId || '', onChange: handleInputChange, disabled: assessmentStore.isLoading, children: [_jsx("option", { value: "", children: "-- Create Assessment Area (No Parent) --" }), assessmentStore.assessmentAreas.map(area => (_jsx("option", { value: area.id, children: area.name }, area.id)))] })] }) }) }))] }), _jsxs(Modal.Footer, { children: [_jsx(Button, { variant: "secondary", onClick: handleClose, disabled: assessmentStore.isLoading, className: "btn-touch w-mobile-100", children: "Cancel" }), _jsxs(Button, { variant: "primary", type: "submit", disabled: assessmentStore.isLoading, className: "btn-touch w-mobile-100", children: [assessmentStore.isLoading && (_jsx(Spinner, { animation: "border", size: "sm", className: "me-2" })), assessmentStore.isEditing ? 'Update' : 'Create'] })] })] })] }));
});
export default AssessmentDialog;
